import { render } from "./Home.vue?vue&type=template&id=f611ae00&scoped=true&ts=true"
import script from "./Home.vue?vue&type=script&lang=ts"
export * from "./Home.vue?vue&type=script&lang=ts"

import "./Home.vue?vue&type=style&index=0&id=f611ae00&lang=scss&scoped=true"

import exportComponent from "D:\\work\\h5\\2024sjAnswer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f611ae00"]])

export default __exports__